import BaseViewController from "./base-view-controller";

const screenCompleteButtons = [
  "continueButton",
  "continue_button",
  "return_to_home",
  "return_to_home_btn",
  "return_to_home_select_new_provider_link"
];

class ConsultationSuccessViewController extends BaseViewController {
  handleButtonClick(name, text, action) {
    if (screenCompleteButtons.includes(name)) {
      if (this.appData.data.actions?.[0]?.type === "url") {
        this.appData.nextScreen({
          data: this.appData.data,
          screenIndex: this.appData.screenIndex,
          formState: this.appData.values,
          action: this.appData.data.actions[0],
          replaceHistory: Number.POSITIVE_INFINITY
        });
      } else {
        this.appData.onExit();
      }

      return;
    }
    super.handleButtonClick(name, text, action);
  }
}
export default ConsultationSuccessViewController;
